import { ReactNode } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

interface DrawerProps {
  isOpen: boolean
  isMobile: boolean
  sidebarWidth?: number
  children: ReactNode
}

export const Drawer = ({ isOpen, isMobile, sidebarWidth = 700, children }: DrawerProps) => {
  const style = isMobile
    ? {
        width: '100%',
        height: '50%',
        left: '0',
        bottom: '0',
        transform: `translate3d(0, ${isOpen ? '0' : 'calc(100% + 100px)'}, 0)`,
        transition: 'transform 0.5s ease-in-out',
        willChange: 'transform',
        zIndex: '10',
      }
    : {
        width: `${sidebarWidth}px`,
        height: '100%',
        right: '0',
        top: '0',
        transform: `translate3d(${isOpen ? '0' : `${sidebarWidth + 100}px`}, 0, 0)`,
        transition: 'transform 0.5s ease-in-out',
        willChange: 'transform',
        zIndex: '10',
      }

  return (
    <Box
      style={style}
      position="absolute"
      paddingY="s12"
      paddingRight="s12"
      paddingLeft={isMobile ? 's12' : 's0'}
    >
      <Box
        background="grey000White"
        flexDirection="column"
        height="full"
        borderRadius={{ all: 'abs016' }}
        boxShadow="s100"
      >
        {children}
      </Box>
    </Box>
  )
}
